var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloudy_sunny"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bright"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cloudy"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "high_rainfall"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "windy"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "rain_with_thunder"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clear_night"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "cloudy_night"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "moon"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "sun"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "rainy_night"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "windy_night"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "night_rain_thunder"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "windy_rain"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "temperature"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.7,35.9C47.3,21.2,29.5,4,28.7,3.3c-0.4-0.4-1-0.4-1.4,0C26.4,4.1,6,23.7,6,39c0,12.1,9.9,22,22,22    c3.4,0,6.7-0.8,9.7-2.3c2.1,1.4,4.6,2.3,7.3,2.3c7.2,0,13-5.8,13-13C58,42.5,54.6,37.8,49.7,35.9z M28,59C17,59,8,50,8,39    C8,26.1,24.4,9,28,5.4C31.3,8.7,45,23,47.6,35.3C46.7,35.1,45.9,35,45,35c-7.2,0-13,5.8-13,13c0,3.7,1.5,7,4,9.3    C33.5,58.4,30.8,59,28,59z M45,59c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S51.1,59,45,59z",
    fill: "#ffe142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,54c-8.3,0-15-6.7-15-15c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,9.4,7.6,17,17,17c0.6,0,1-0.4,1-1S28.6,54,28,54z",
    fill: "#ffe142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4,40.1c-0.5-0.2-1.1,0-1.3,0.5l-6,14c-0.2,0.5,0,1.1,0.5,1.3C41.7,56,41.9,56,42,56c0.4,0,0.8-0.2,0.9-0.6l6-14    C49.1,40.9,48.9,40.3,48.4,40.1z",
    fill: "#ffe142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,44c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3S44,45.7,44,44z M40,44c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S40,44.6,40,44z",
    fill: "#ffe142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,49c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S50.7,49,49,49z M49,53c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S49.6,53,49,53z",
    fill: "#ffe142"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "humidity"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "air_pressure"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "low_rainfall"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "moderate_rainfall"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Sunset"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.4a9b942f854f1eda271f125447dc0a23.svg";
export { ForwardRef as ReactComponent };